import React, { useContext } from 'react'
import CommonContext from '../../hooks/CommonContext';
import { useLocation } from 'react-router-dom';
import { handleReset } from 'Actions/commonAction/milleSearchFilterActions';
import { useDispatch } from 'react-redux';

const Sorting = ({ sortBy, setSortBy, setFilter }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { setAnswer, setSelectedCardIndex, setCurrentPage, gettingResponse, cardArrayDuplicate,
        getHomeAll, setapplyFilterResponse, setSortByForPagination, getAppliedDatas, getSavedDatas,
        setIsApplyFilterClicked, initializeReset, setIsSearched, setIsMellieSearch
    } = useContext(CommonContext);



    const handleRoute = (sortParams) => {
        switch (location.pathname) {
            case "/professional/all_jobs":
            case "/professional/all_jobs/":
                getHomeAll(undefined, undefined, sortParams)
                break;

            case "/professional/applied_jobs":
            case "/professional/applied_jobs/":
                getAppliedDatas(undefined, undefined, sortParams)
                break;

            case "/professional/saved_jobs":
            case "/professional/saved_jobs/":
                getSavedDatas(undefined, undefined, sortParams)
                break;

            default:
                break;
        }
    }

    const handleSortingFilter = (sortValue) => {
        if (cardArrayDuplicate.length > 0) {
            setIsApplyFilterClicked(false)
            dispatch(handleReset())
            initializeReset()

            setSelectedCardIndex(0);
            setapplyFilterResponse(true);
            setAnswer([])

            setCurrentPage(0);
            setFilter(sortValue)
            setIsSearched(false)
            setIsMellieSearch(false)
            switch (sortValue) {
                case "Default":
                    setSortBy("Default")
                    handleRoute("")
                    break;

                case "DateLatest":
                    setSortBy("Date Latest")
                    setSortByForPagination("by_date_desc")
                    handleRoute("by_date_desc")
                    break;

                case "DateOldest":
                    setSortBy("Date Oldest")
                    setSortByForPagination(window.location.pathname === "/professional/applied_jobs" || window.location.pathname === "/professional/saved_jobs" ? "by_date_asc" : 'by_date')
                    handleRoute(window.location.pathname === "/professional/applied_jobs" || window.location.pathname === "/professional/saved_jobs" ? 'by_date_asc' : 'by_date')
                    break;

                case "NameAscending":
                    setSortBy("A-Z")
                    setSortByForPagination("asc")
                    handleRoute('asc')
                    break;

                case "NameDescending":
                    setSortBy("Z-A")
                    setSortByForPagination("desc")
                    handleRoute('desc')
                    break;

                default:
                    break;
            }
        }
    }

    return (
        <div className="col-12 col-sm-6 ">
            {
                gettingResponse === false ? <label className=" w-100">
                    <span className="placeholder w-100 rounded py-2 pt-3"></span>
                </label>
                    :
                    <div className='d-flex align-items-center pt-3 pt-sm-0'>
                        <div className='col-3 col-sm-4 text-start text-sm-end pe-2'>
                            <label className='m-0 filter-results'>Sort by</label>
                        </div>
                        <div className='col-9 col-sm-8 dropdown custom-dropdown'>
                            <button id='professionalHomeSortBy' className="btn btn-secondary dropdown-toggle w-100 border-0 outline-none filter-section" type="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                {sortBy === "" ? "Date Latest" : sortBy}
                            </button>
                            <ul className="dropdown-menu" >
                                {
                                    ["/professional/all_jobs", "/professional/all_jobs/", "/professional/saved_jobs", "/professional/saved_jobs/"]?.includes(window?.location?.pathname) ?
                                        <li id='professionalDatePosted' className='cursorPointer p-1 px-2 dropdown-item' onClick={() => handleSortingFilter("Default")}>Default</li>
                                        :
                                        null
                                }
                                <li id='professionalDatePosted' className='cursorPointer p-1 px-2 dropdown-item' onClick={() => handleSortingFilter("DateLatest")}>Date Latest</li>
                                <li id='professionalDatePosted' className='cursorPointer p-1 px-2 dropdown-item' onClick={() => handleSortingFilter("DateOldest")}>Date Oldest</li>
                                <li id='professionalA-Z' className='cursorPointer p-1 px-2 dropdown-item' onClick={() => handleSortingFilter("NameAscending")}>A-Z</li>
                                <li id='professionalZ-A' className='cursorPointer p-1 px-2 dropdown-item' onClick={() => handleSortingFilter("NameDescending")}>Z-A</li>
                            </ul>
                        </div>
                    </div>
            }
        </div>
    )
}

export default Sorting
